/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BundleDetailAvailableActionsEnum {
    CLOSE = 'CLOSE',
    SENT = 'SENT',
    UNSENT = 'UNSENT'
}
